module.exports = __webpack_public_path__ + "static/media/16.e4e7e369.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/16.jpg
// module id = 177
// module chunks = 0